export default {
    environment : process.env.VUE_APP_ENV
};
